import type { MapMouseEvent } from 'mapbox-gl';
import {
  MapStoreyPointFeature,
  MapStoreyPolygonFeature,
} from '../models/map-feature.models';
import { guards } from '@shared/helpers/typeguards.helpers';

const isFeature = (feature?: GeoJSON.Feature): feature is GeoJSON.Feature => {
  return feature?.type === 'Feature';
};

const isMapStoreyPointFeature = (
  feature?: GeoJSON.Feature,
): feature is MapStoreyPointFeature => {
  return isFeature(feature) && feature.geometry.type === 'Point';
};

const isMapStoreyPolygonFeature = (
  feature?: GeoJSON.Feature,
): feature is MapStoreyPolygonFeature => {
  return isFeature(feature) && feature.geometry.type === 'Polygon';
};

/**
 * Runtime guard for Mapbox GL {@link MapMouseEvent}.
 */
const isMapMouseEvent = (event: unknown): event is MapMouseEvent => {
  if (!guards.is.object(event)) return false;
  return (
    typeof event.type === 'string' &&
    'lngLat' in event &&
    typeof event.lngLat === 'object' &&
    event.lngLat !== null
  );
};

export const mapGuards = {
  is: {
    feature: {
      any: isFeature,
      point: isMapStoreyPointFeature,
      polygon: isMapStoreyPolygonFeature,
    },
    mapMouseEvent: isMapMouseEvent,
  },
};
